module.exports = __webpack_public_path__ + "img/add_icon.295b9a1c.svg";